/**
 * Add classes on body based on browser device
 */
export function addDeviceClasses()
{
  let is_ios = ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0;
  if (is_ios) $('body').addClass('is-ios')
  let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (isSafari) $('body').addClass('is-safari')

}
